// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"Input_mainContainer__2YA1z","input":"Input_input__bQgFS","error":"Input_error__3xS5W"};